import React from 'react';

import BigTitle from "../BigTitle";
import {FormattedMessage} from "react-intl";

import flight_img from "../../assets/img/services/meet_and_greet/flight.jpg"
import hotel_img from "../../assets/img/services/meet_and_greet/hotel.jpg"
import visa_img from "../../assets/img/services/meet_and_greet/visa.jpg"
import work_permit_img from "../../assets/img/services/meet_and_greet/work_permit.jpg"
import shuttle_img from "../../assets/img/services/meet_and_greet/shuttle.jpg"


const cardStyle = {
    maxWidth: 350,
    boxShadow: '0 0 5px 0 #00000038',
    borderRadius: 10,
    padding: 5,
    paddingBottom: 30,
    margin: 27
};

export default class MEETandGREET extends React.Component {


    render() {

        return <div className={"meet_and_greet"} dir={this.props.lang === "ar" ? "rtl" : "ltr"}>

            <div className={"r "}>
                <div className={"c-1-1"}>
                    <BigTitle title={<FormattedMessage id={"meet_and_greet.title"}/>} isYellow/>

                    <div className={"r"}>
                        <div className={"c-1-1"}>
                            <div className={"c-1-1"}>
                                <p><FormattedMessage id={"meet_and_greet.description.p1"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.description.p2"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.description.p3"}/></p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div style={{
                display: "flex",
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'flex-start',
                alignContent: 'stretch'
            }}
            >

                <div style={cardStyle}>
                    <BigTitle title_style={{color: 'black', height: 120}} sub_style={{paddingTop: 0}}
                              title={<FormattedMessage id={"meet_and_greet.flight.title"}/>}/>
                    <img alt="meet_and_greet_photo" className={"flight_bg"} src={flight_img}/>

                    <div className={"r"}>
                        <div className={"c-1-1"}>
                            <div className={"c-1-1"}>
                                <p><FormattedMessage id={"meet_and_greet.flight.description"}/></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={cardStyle}>
                    <BigTitle title_style={{color: 'black', height: 120}} sub_style={{paddingTop: 0}}
                              title={<FormattedMessage id={"meet_and_greet.hotel.title"}/>}/>
                    <img alt="meet_and_greet_photo" className={"flight_bg"} src={hotel_img}/>

                    <div className={"r"}>
                        <div className={"c-1-1"}>
                            <div className={"c-1-1"}>
                                <p><FormattedMessage id={"meet_and_greet.hotel.description.p1"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.hotel.description.p2"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.hotel.description.p3"}/></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={cardStyle}>
                    <BigTitle title_style={{color: 'black', height: 120}} sub_style={{paddingTop: 0}}
                              title={<FormattedMessage id={"meet_and_greet.visa.title"}/>}/>
                    <img alt="meet_and_greet_photo" className={"flight_bg"} src={visa_img}/>

                    <div className={"r"}>
                        <div className={"c-1-1"}>
                            <div className={"c-1-1"}>
                                <p><FormattedMessage id={"meet_and_greet.visa.description.p1"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.visa.description.p2"}/></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={cardStyle}>
                    <BigTitle title_style={{color: 'black', height: 120}} sub_style={{paddingTop: 0}}
                              title={<FormattedMessage id={"meet_and_greet.work_permit.title"}/>}/>
                    <img alt="meet_and_greet_photo" className={"flight_bg"} src={work_permit_img}/>

                    <div className={"r"}>
                        <div className={"c-1-1"}>
                            <div className={"c-1-1"}>
                                <p><FormattedMessage id={"meet_and_greet.work_permit.description.p1"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.work_permit.description.p2"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.work_permit.description.p3"}/></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={cardStyle}>
                    <BigTitle title_style={{color: 'black', height: 120}} sub_style={{paddingTop: 0}}
                              title={<FormattedMessage id={"meet_and_greet.airport_shuttle.title"}/>}/>
                    <img alt="meet_and_greet_photo" className={"flight_bg"} src={shuttle_img}/>

                    <div className={"r"}>
                        <div className={"c-1-1"}>
                            <div className={"c-1-1"}>
                                <p><FormattedMessage id={"meet_and_greet.airport_shuttle.description.p1"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.airport_shuttle.description.p2"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.airport_shuttle.description.p3"}/></p>
                                <p><FormattedMessage id={"meet_and_greet.airport_shuttle.description.p4"}/></p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    }

}


// WEBPACK FOOTER //
// ./src/components/pages/MEETandGREET.js